"use strict";

var _require = require('react'),
    e = _require.createElement;

module.exports = function (_ref) {
  var title = _ref.title,
      content = _ref.content,
      _ref$state = _ref.state,
      state = _ref$state === void 0 ? {} : _ref$state,
      _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? ['/main.css'] : _ref$styles,
      _ref$scripts = _ref.scripts,
      scripts = _ref$scripts === void 0 ? ['/main.js'] : _ref$scripts;
  return e('html', {}, e('head', {}, e('title', {}, title), e('meta', {
    charSet: 'utf-8'
  }), e('meta', {
    name: 'viewport',
    content: 'width=device-width, initial-scale=1'
  }), styles.map(function (s, i) {
    return e('link', {
      rel: 'stylesheet',
      href: s,
      key: i
    });
  })), e('body', {}, e('main', {
    id: 'mount',
    dangerouslySetInnerHTML: {
      __html: content
    }
  }), e('script', {
    id: 'initial-state',
    type: 'application/json',
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(state)
    }
  }), scripts.map(function (s, i) {
    return e('script', {
      src: s,
      key: i
    });
  })));
};